import { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { CookieBanner } from './CookieBanner';
import GeoRestriction from './GeoRestriction';

interface GeoRestrictedLayoutProps {
  children: ReactNode;
}

const GeoRestrictedLayout = ({ children }: GeoRestrictedLayoutProps) => {
  return (
    <GeoRestriction>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">{children}</main>
        <Footer />
        <CookieBanner />
      </div>
    </GeoRestriction>
  );
};

export default GeoRestrictedLayout;
